import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ITreatyState } from '../reducers/treaty.reducer';

export const getTreatyState = createFeatureSelector<ITreatyState>(
  'treaty'
);

export const getOtherDocument = createSelector(
  getTreatyState,
  (state: ITreatyState) => state.otherDocuments
);
